import { useState, useContext } from 'react'
import dynamic from 'next/dynamic'
import { useRouter } from 'next/router'
import { useFormik } from 'formik';
import * as Yup from 'yup';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import style from './loginSignUp.module.css'
import signUp from '../../../lib/signup'
import { FirebaseAuthContext } from '../../../context/firebaseAuthContext'

const CustomButton = dynamic(() => import('../../buttons/customButton'))
const AlertModal = dynamic(() => import('../../modals/modalAlert'))
const LoadingComponent = dynamic(() => import('../../shared/loadingComponent'))

export default function SignUpFormComponent() {

    const authApi = useContext(FirebaseAuthContext)
    const { user, loading } = authApi

    const router = useRouter()

    const [show, setShow] = useState(false)
    const handleClose = () => setShow(false);

    const [message, setMessage] = useState('')
    const [disabled, setDisabled] = useState(false)

    const formik = useFormik({
        initialValues: {
            email: '',
            password: '',
            cpassword: ''
        },
        validationSchema: Yup.object({
            password: Yup.string()
                .min(7, 'Must be 7 or more')
                .max(50, 'Must be 50 characters or less')
                .required('Required'),
            cpassword: Yup.string()
                .oneOf([Yup.ref('password'), null], 'Passwords must match')
                .required('Password confirm is required'),
            email: Yup.string().email('Invalid email address').required('Required')
        }),
        onSubmit: async (values) => {
            setDisabled(true)
            try {
                let myResp = await signUp(values.email.trim(), values.password.trim())

                if (myResp.error?.customData?._tokenResponse?.error?.code === 400) {
                    await setMessage('The email already in use!')
                    await formik.resetForm()
                    await setShow(true)
                    setTimeout(() => {
                        handleClose()
                        router.push('/')
                    }, 4000)
                } else if (myResp.result !== null) {
                    await formik.resetForm()
                    await setMessage('Congratulations! You successfully created account with Fl Gold Coin Exchange.')
                    await setShow(true)
                    if (show === false) {
                        await setTimeout(() => {
                            handleClose()
                            router.push('/')
                        }, 4000)
                    } else {
                        await setTimeout(() => {
                            handleClose()
                            router.push('/')
                        }, 6000)
                    }
                } else {
                    router.push('/')
                }

            } catch (e) {
                console.log('signUp error: ' + e)
            }
        },
    });
    if (loading) {
        return (<LoadingComponent />)
    }
    if (user !== null && show === true) {
        return (<AlertModal
            show={show}
            alert={message}
            handleClose={handleClose}
        />)
    }
    if (user === null) {
        return (<>
            <article className='sectionOrArticleTB'>
                <Container>
                    <Row className="justify-content-center" >
                        <Col xs={12} md={8} lg={6} className='text-center'>
                            <form onSubmit={formik.handleSubmit} className={style.formBox}>
                                <h1 className='caregoriesTitle'>Sign Up</h1><br />
                                <label htmlFor="email">Email Address*:</label><br />
                                <input
                                    id="email"
                                    className={style.formInputs}
                                    name="email"
                                    type="email"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.email}
                                />
                                {formik.touched.email && formik.errors.email ? (
                                    <div className={style.errorColor}>{formik.errors.email}</div>
                                ) : null}
                                <br /> <br />
                                <label htmlFor="firstName">Password*:</label><br />
                                <input
                                    id="lastName"
                                    className={style.formInputs}
                                    name="password"
                                    type="password"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.password}
                                />
                                {formik.touched.password && formik.errors.password ? (
                                    <div className={style.errorColor}>{formik.errors.password}</div>
                                ) : null}
                                <br />  <br />
                                <label htmlFor="firstName">Confirm Password*:</label><br />
                                <input
                                    id="cpassword"
                                    className={style.formInputs}
                                    name="cpassword"
                                    type="password"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.cpassword}
                                />
                                {formik.touched.cpassword && formik.errors.cpassword ? (
                                    <div className={style.errorColor}>{formik.errors.cpassword}</div>
                                ) : null}
                                <br />  <br />
                                <CustomButton type="submit" maroonBtn disabled={disabled}>Sign Up</CustomButton>
                            </form>
                        </Col>
                    </Row>
                </Container>
            </article>
        </>)
    }
}